export default __webpack_public_path__ + "static/media/TeamsSlack.50315a66.png";